// extracted by mini-css-extract-plugin
export var circle = "_8r-1";
export var exitConfirmationModal = "_8r-5";
export var iframe = "_8r-0";
export var offline = "_8r-3";
export var online = "_8r-2";
export var workstationSelectError = "_8r-4";